import type { LanguageOverride } from '../types';

// Te reo Māori overrides — empty initially, ready for future translations
export const miOverrides: LanguageOverride = {
  base: {},
  platforms: {},
};
